<template>
    <div class="XscpWaitingFailure CardReaderSubComponent">
        <v-alert
            class="CardReaderSubComponent-alert"
            color="warning"
            variant="tonal"
        >
            <div
                class="CardReaderSubComponent-title"
                v-text="$t('card_reader:launch_program:xscp_launch_waiting_failure:message')"
            />
            <span
                class="CardReaderSubComponent-description"
                v-text="$t('card_reader:launch_program:xscp_launch_waiting_failure:instructions:message')"
            />
        </v-alert>
        <v-btn
            class="CardReaderSubComponent-button"
            color="primary"
            variant="flat"
            @click="refreshPage"
        >
            {{ $t('card_reader:refresh_page_button_text') }}
        </v-btn>
    </div>
</template>

<script setup>
function refreshPage () {
    // Clean localstorage from previous installed things related to the card reader
    localStorage.removeItem('installedXscpVersion')
    localStorage.removeItem('isCardReaderInstallStepDone')

    localStorage.setItem('openCardReaderAfterRefresh', true)
    window.location.reload()
}
</script>

<style lang="scss" scoped>
@import 'globalScss';
</style>
